import request from "@/utils/request";
// 获取转发列表
export function getTranspondListApi(item_id, data) {
  return request({
    method: "GET",
    url: `items/${item_id}/forwards`,
    params: data
  });
}

// 获取评论列表
export function getCommentListApi(item_id, data) {
  return request({
    method: "GET",
    url: `items/${item_id}/comments`,
    params: data
  });
}

// 获取评论列表
export function getLikeListApi(item_id, data) {
  return request({
    method: "GET",
    url: `items/${item_id}/likes`,
    params: data
  });
}

// 发表评论
export function publishCommentApi(item_id, data) {
  return request({
    method: "POST",
    url: `items/${item_id}/comments`,
    data
  });
}

// 评论点赞接口
export function commentsLikeApi(item_id, comment_id) {
  return request({
    method: "POST",
    url: `items/${item_id}/comments/${comment_id}/likes`
  });
}

// 取消评论点赞接口
export function cancelCommentsLikeApi(item_id, comment_id) {
  return request({
    method: "DELETE",
    url: `items/${item_id}/comments/${comment_id}/likes`
  });
}
